import { getImageUrl } from './utils';
import { useState, useEffect, useMemo } from 'react';
//import CustomPhotoEditor from './MyPhotoEditor';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';

import Box from '@mui/material/Box';
import { createTheme, styled } from '@mui/material/styles';
import { AutoFixHigh, AutoAwesome, AppShortcut, ControlCamera, PortraitRounded} from '@mui/icons-material';
import Paper from '@mui/material/Paper';
import {SinglePage} from './SinglePage';

//import 'react-photo-editor/dist/style.css'

//import './App.css';


// https://huggingface.co/spaces/modelscope/ReplaceAnything
// https://huggingface.co/spaces/PAIR/HD-Painter


function Avatar({ person, size }) {
  return (
    <img
      className="avatar"
      src={getImageUrl(person)}
      alt={person.name}
      width={size}
      height={size}
    />
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

function imagestep({ id, size }) {
  return (
    <img
      className="imgstep"
      src=""
      id={id}
      width={size}
      height={size}
    />
  );
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const NAVIGATION = [

  {
    kind:'header',
    title:'mode',
  },
  {
    segment: 'Load_Image',
    title: 'Select Image',
    icon: <AutoFixHigh />,
  },
];

const NONAVIGATION = [

  {
    kind:'header',
    title:'mode',
  },
  {
    segment: 'Load_Image',
    title: 'Select Image',
    icon: <AutoFixHigh />,
  },
  { kind: 'divider' },
  {
    segment: 'AI',
    title: 'AI',
    icon: <AppShortcut />,
  },
  { kind: 'divider' },
  {
    segment: 'Show_portrait',
    title: 'show',
    icon: <PortraitRounded />,
  },
];

const demoTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: { light: true, dark: true },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});




//var file, setFile, showModal, setShowModal;

function App() {
  const [canopen, setCanopen] = useState();
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState();
  

  useEffect(() =>{
    if(file){
      setShowModal(true);
    }
    
  },[file]);


  
   // Show modal if file is selected
  const showModalHandler = () => {
    if (file) {
      setShowModal(true);
    }
  }


  // Hide modal
  const hideModal = () => {
    setShowModal(false);
  }

  // Save edited image
  const handleSaveImage = (editedFile) => {
    setFile(editedFile);
  }

  const setFileData = (e) => {
    if (e?.target?.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
      showModalHandler();
    }
  }

  const [pathname, setPathname] = useState('Load_Image');

  const router = useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    };
  }, [pathname]);

  const demoWindow = undefined;
 /*
 <Button component="label" tabIndex={-1} role={undefined} variant="contained" startIcon={<FileUploadIcon />}>Upload image
          <VisuallyHiddenInput  type="file" onChange={(e) => setFileData(e)} multiple={false}/>
        </Button>
        <Typography>Dashboard content for {pathname}</Typography>
        { file && 
            <CustomPhotoEditor file={file}/>
        
            */
  const DemoPageContent = () => {
    return (
      <Box
        sx={{
          py: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
      </Box>
    );
  
  };
  /*
   <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <Card>
          <Avatar size={100} person={{name:'pluto', imageId: 'YfeOqp2'}}/>
          <Avatar size={50} person={{name:'pippo', imageId: '1bX5QH6'}}/>        
        </Card>
        <Card>
          
          <input  accept="image/png, image/jpeg, image/jpg" type="file" onChange={(e) => setFileData(e)} multiple={false} />

        </Card>
        <Card>{ file && 
          <ReactPhotoEditor
            modalHeight={700}
            open={showModal}
            onClose={hideModal}
            file={file}
            onSaveImage={handleSaveImage}
          />
        }
        </Card>
        <Card>
          <CustomPhotoEditor/>
        </Card>
          </header>
    </div>
    */

  return (

    <AppProvider
      navigation={NAVIGATION}
      branding={{
        logo: <img src="./occhio.png" alt="EYE editor logo" />,
        title: 'EYE image editor',
      }}
      router={router}
      theme={demoTheme}
      window={demoWindow}
    >
       
      
      <DashboardLayout>
        <Box
          sx={{
            py: 4,
            px: 2,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <SinglePage mode={pathname}/>
          
             
        </Box>
       
      </DashboardLayout>
    </AppProvider>


  );
}

export default App;


/*
<Grid container spacing={2}>
<Grid size={3}>
<Item>

</Item>
</Grid>
<Grid size={9}>
<Item>
  
</Item>
</Grid>
</Grid>
*/